/**
 * Strip Lithuanian, Russian and other Slavic/European diacritics for
 * case-and-accent-insensitive comparisons. Used so users can type "Siauliai"
 * and still match "Šiauliai", "Marijampole" → "Marijampolė", etc.
 */
export function normalize(s) {
  if (s == null) return "";
  return String(s)
    .toLowerCase()
    // Normalize Unicode and remove combining marks (covers most accents).
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    // Lithuanian "ė" sometimes survives NFD; handle a few stragglers explicitly.
    .replace(/ė/g, "e")
    .replace(/į/g, "i")
    .replace(/ų/g, "u")
    .replace(/ū/g, "u")
    .replace(/ą/g, "a")
    .replace(/č/g, "c")
    .replace(/š/g, "s")
    .replace(/ž/g, "z")
    .replace(/ё/g, "e")
    .trim();
}
